import React, { useCallback } from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices, Button,
    Edit, SimpleForm, TextInput,ReferenceInput, SelectInput,
    DateInput, BooleanInput, NumberInput,FileInput, FileField,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { useForm } from 'react-final-form';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../common/apiClient";
import CreateToolbar from "../../CreateToolbar";
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from "../../formStyles";

const PostCreateToolbar = props => (
    
    <Toolbar {...props}>
        <SaveButton submitOnEnter={true}  onSave={props.onSave} />
        <Button
        variant="contained" color="primary"
        label="Back" size="medium"
        startIcon={<CancelIcon />}
        style={{marginLeft:"30px"}}
        onClick={props.onCancel}
        />
    </Toolbar>
);
const ContactEdit = props => {
    const classes = useStyles({});
    
    const handleSubmit = (formdata) => {
        console.log(formdata);
        apiClient.updateRecord("customer-contacts", formdata).then(res => {
            console.log(res);
            props.onClose();
        }).catch(err => {
            console.log(err);
        });
        
        
    }
    return (
        <Edit {...props} id={props.record.id} resource="customer-contacts" redirect="false">
            <SimpleForm
                onSubmit={handleSubmit} 
                toolbar={
                <PostCreateToolbar label="Save " onSave={handleSubmit} onClose={props.onClose}  onCancel={props.onCancel} 
                 />}
                variant="outlined">
                 <TextInput source="name" label="Name" validate={required()} fullWidth={true} />
                <TextInput source="shortName" label="Short Name"  fullWidth={true} />
                <TextInput source="designations" validate={required()} fullWidth={true} />
                <DateInput fullWidth={true} source="dob" validate={required()} label="Dob" /> 
                <TextInput fullWidth={true} source="phone" validate={required()} label="Phone" initialValue={""}/>
                <TextInput fullWidth={true} source="mobile" validate={required()} label="Mobile" initialValue={""} />
                <TextInput fullWidth={true} source="email" validate={required()} label="Email" initialValue={""}/> 
                <BooleanInput source="isActive" label="Is Active" initialValue={true}/>  
            </SimpleForm>
        </Edit>
    );
}
export default ContactEdit;